import { Flex } from '@common/components/Flex';
import { InfoIcon } from '@common/components/info-icon';

import './info-message.styles.scss';

export const InfoMessage = (props) => {
	const { children } = props;

	return (
		<Flex className="InfoMessage">
			<InfoIcon margin="0 8px 0 0" />
			<div className="InfoMessage__children">{children}</div>
		</Flex>
	);
};